<template>
  <b-modal
    :id="modalId"
    centered
    hide-header
    :cancel-title="$t('button.cancel.label')"
    cancel-variant="danger"
    :ok-title="$t('button.save.label')"
    ok-variant="success"
    footer-bg-variant="dark"
    @show="onShow"
    @ok="onOk"
  >
    <form ref="form" @submit.stop.prevent="handleSubmit">
      <b-form-group
        :label="$t('form.direction.label')"
        label-for="input-direction"
        :invalid-feedback="$t('message.error.requiredField')"
      >
        <b-form-select
          id="input-direction"
          v-model="form.direction"
          :options="directions"
          :state="validateState('direction')"
          size="md"
        ></b-form-select>
      </b-form-group>

      <b-form-group
        v-if="form.direction === 'SUP'"
        :label="$t('form.box.label')"
        label-for="input-box-id"
      >
        <b-form-select
          id="input-box-id"
          v-model="form.boxId"
          size="md"
          :options="boxeOptions"
          :placeholder="$t('form.box.label')"
        ></b-form-select>
      </b-form-group>
      <b-form-group
        :label="$t('form.supportRequestContent.label')"
        label-for="input-content"
        :invalid-feedback="$t('message.error.requiredField')"
      >
        <b-form-textarea
          id="input-content"
          ref="content"
          v-model="form.content"
          :placeholder="$t('form.supportRequestContent.placeholder')"
          :rows="5"
          :state="validateState('content')"
        ></b-form-textarea>
      </b-form-group>
    </form>
  </b-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import boxesQuery from '@/api/boxinfo/boxList.gql';
import addSupportRequest from '@/api/support/mutations/addSupportRequest.gql';

export default {
  name: 'NewRequestModalCommon',
  mixins: [validationMixin],
  props: {
    modalId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      directions: [
        { value: null, text: this.$t('form.direction.placeholder') },
        { value: 'SUP', text: this.$t('support.direction.sup.label') },
        { value: 'SAL', text: this.$t('support.direction.sal.label') },
      ],
      form: {
        direction: null,
        content: '',
        boxId: null,
      },
    };
  },
  validations: {
    form: {
      content: {
        required,
      },
      direction: {
        required,
      },
    },
  },
  apollo: {
    boxes: {
      query() {
        return boxesQuery;
      },
      deep: true,
      update(data) {
        const queryData = data[Object.keys(data)[0]];
        if (queryData && queryData.boxes && queryData.boxes.length) {
          return queryData.boxes;
        } else {
          return null;
        }
      },
      error(e) {
        this.$store.commit('SET_ERROR', e.message);
      },
    },
  },
  computed: {
    boxeOptions() {
      let res = [{ value: null, text: this.$t('form.box.placeholder') }];
      let boxes = this.boxes || [];

      boxes.forEach((el) =>
        res.push({
          value: el.deviceId,
          text: el.digitalThing.name,
        }),
      );

      return res;
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onOk(e) {
      e.preventDefault();

      this.handleSubmit();
    },
    onShow() {
      this.form = { direction: null, content: '', boxId: null };
      this.$v.form.$reset();
    },
    handleSubmit() {
      // Exit when the form isn't valid
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      this.$apollo
        .mutate({
          mutation: addSupportRequest,
          variables: {
            boxId: this.form.boxId,
            content: this.form.content,
            directionId: this.form.direction,
          },
        })
        .then(() => {
          this.$bvToast.toast(this.$t('support.newRequest.successMessage'), {
            title: this.$t('toast.success'),
            variant: 'success',
            solid: true,
          });
        })
        .catch((e) => {
          this.$bvToast.toast(this.$t('support.newRequest.failedMessage'), {
            title: this.$t('toast.error'),
            variant: 'danger',
            solid: true,
          });
          console.log(e.message);
        });

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide(this.modalId);
      });
    },
  },
};
</script>
